import ar from './locale/ar';
import en from './locale/en';
import deepMergeObjects from '../../shared/helpers/deepMergeObjects';

// Get brand name from global config
const brand = window.globalConfig?.BRAND_NAME || '';

let defaultMessages = {
  en,
  ar,
};

// Function to load brand-specific messages
function loadBrandMessages() {
  if (brand && brand.trim() !== '') {
    try {
      console.log(`Loading brand-specific translations for "${brand}"...`);
      
      // Try to import brand-specific messages dynamically for any brand
      let brandEn = {};
      let brandAr = {};
      
      try {
        // Import the brand-specific translations using require with template literal
        const brandEnModule = require(`./locale-${brand}/en/index.js`);
        const brandArModule = require(`./locale-${brand}/ar/index.js`);
        
        brandEn = brandEnModule.default || brandEnModule;
        brandAr = brandArModule.default || brandArModule;
        
        console.log(`Successfully loaded ${brand} brand translations`);
      } catch (importError) {
        console.warn(`Could not import ${brand} brand translations:`, importError);
      }

      const brandMessages = {
        en: brandEn,
        ar: brandAr,
      };

      // Merge brand messages with default messages
      defaultMessages = deepMergeObjects(defaultMessages, brandMessages);
    } catch (error) {
      console.warn(
        `Brand-specific translations for "${brand}" not found or failed to load:`,
        error
      );
    }
  }

  return defaultMessages;
}

// Load brand messages immediately
const messages = loadBrandMessages();

export default messages;
